import {
  Text,
  Flex,
  Input,
  Button,
  FormControl,
  FormErrorMessage,
} from '@everlywell/ui-kit';
import DynamicIcon from 'components/DynamicIcon';
import React, { useState } from 'react';
import { sendNotificationEvent } from 'utils/api/subscriptionsApi';
import { User } from 'utils/types';

import { LearnMoreFormProps } from '../InteractiveBanner';

const LearnMoreForm: React.FC<LearnMoreFormProps | null> = (props) => {
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!props || !props.learnMoreForm) {
    return null;
  }

  const { learnMoreForm } = props;

  const handleSubscriptionSubmit: React.FormEventHandler<
    HTMLFormElement
  > = async (event, user = {} as User) => {
    event.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');
    setIsSubmitting(true);

    if (!email) {
      setErrorMessage('Error: Email is required.');
      setIsSubmitting(false);
      return;
    }

    try {
      sendNotificationEvent({
        event_type: 'newsletter-subscription',
        resource: {
          user_id: user.id,
          email: email,
          data_fields: {
            newsletter: 'weight-care-plus',
          },
        },
      });
      setSuccessMessage('Thank you, we will get in contact soon.');
    } catch (error) {
      setErrorMessage('Email submission failed, please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Flex flex={1}>
      {learnMoreForm?.map((item, index) => (
        <Flex
          padding={6}
          borderRadius={'lg'}
          key={index}
          backgroundColor={item.metadata.theme.backgroundColor}
          minHeight={['unset', '330px']}
          display="flex"
          flexFlow={'column'}
          justifyContent={'space-evenly'}
          width="100%"
        >
          <Text
            color={item.metadata.theme.primaryColor}
            size="lg"
            textAlign="left"
          >
            {item.eyebrow}
          </Text>

          <Text
            color={item.metadata.theme.textColor}
            fontSize={['2xl', '5xl']}
            maxWidth={[null, '400px']}
            marginBottom={[4, 20]}
          >
            {item.metadata.title}
          </Text>

          <form onSubmit={handleSubscriptionSubmit}>
            <FormControl isInvalid={!!errorMessage}>
              {errorMessage && (
                <FormErrorMessage>{errorMessage}</FormErrorMessage>
              )}
              <Flex gap={3} alignItems="center">
                {successMessage ? (
                  <>
                    <DynamicIcon
                      icon="CheckCircle"
                      color="eggplant.light"
                      weight="fill"
                    />
                    <Text color={'eggplant.light'} size="xl">
                      {successMessage}
                    </Text>
                  </>
                ) : (
                  <>
                    <Input
                      placeholder="Type your email"
                      name="subscribeEmail"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      isDisabled={isSubmitting}
                    />

                    <Button
                      variant="primary"
                      type="submit"
                      size="sm"
                      isLoading={isSubmitting}
                    >
                      Submit
                    </Button>
                  </>
                )}
              </Flex>
            </FormControl>
          </form>
        </Flex>
      ))}
    </Flex>
  );
};

export default LearnMoreForm;
